import React, { useMemo } from "react";

import { useLocalContent } from "~/sdks/LocalContent/context";
import type { ScoreKey } from "~/sdks/LocalContent/types";

import * as styles from "./styles";

export function ScoreValue({
  scoreKey,
  value,
}: {
  scoreKey?: ScoreKey;
  value?: number;
}) {
  const { hideScoresList } = useLocalContent();

  const hide = useMemo(
    () => typeof scoreKey === "undefined" || hideScoresList.includes(scoreKey),
    [scoreKey, hideScoresList]
  );

  if (hide || typeof value !== "number" || value <= 0) {
    return null;
  }

  return (
    <div className={styles.container} data-testid="score-value">
      {value > 10 ? 10 : value} / 10
    </div>
  );
}
